import { render, staticRenderFns } from "./storageInfo.vue?vue&type=template&id=338d3fd0&scoped=true"
import script from "./storageInfo.vue?vue&type=script&lang=js"
export * from "./storageInfo.vue?vue&type=script&lang=js"
import style0 from "./storageInfo.vue?vue&type=style&index=0&id=338d3fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d3fd0",
  null
  
)

export default component.exports